// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"bfe81a51b6d27601cabb","293":"8ec449ac1487318bd15f"}[chunkId] + ".js";
};